import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { getFormValues, reduxForm } from 'redux-form/immutable';
import { connect } from 'react-redux';

// actions
import { currentRepUpdate } from '../../../actions/currentRepActions';
import { initialize } from 'redux-form';

// components
import { Button, Error, PhoneNumberInput } from '../../shared/_form';
import { SimplePanel } from '../../shared/_panel';
import { Field } from 'redux-form/immutable';

// constants
const FORM_NAME = 'repEdit';

class PersonalInfo extends React.Component {
    static propTypes = {
      currentUser: PropTypes.instanceOf(Immutable.Map),
      formValues:  PropTypes.instanceOf(Immutable.Map)
    };

    constructor(props) {
      super(props);

      this.state = { data: Immutable.Map() };
    }

    componentDidMount() {
      this._initForm(this.props);
    }

    componentWillReceiveProps(nextProps) {
      this._initForm(nextProps);
    }

    render() {
      const currentUser = this.props.currentUser;
      const errors      = this.props.currentUser.get('error') || Immutable.Map();
      const form        = this.state.data.get('form') || {};

      return (
        <form onSubmit={ this._handleSubmit }>
          <div className='rep-edit__container'>
            <div className='rep-edit__group'>
              <div className='rep-edit__label'>
                <label htmlFor='name'>Name:</label>
              </div>
              <div className='rep-edit__field'>
                <Field className='form__field form__field--rounded'
                  component='input'
                  name='name'
                  type='text' />
                <Error>{ errors.get('name') }</Error>
              </div>
            </div>
            <div className='rep-edit__group'>
              <div className='rep-edit__label'>
                <label htmlFor='name'>Company:</label>
              </div>
              <div className='rep-edit__field'>
                <Field className='form__field form__field--rounded'
                  component='input'
                  name='company'
                  type='text' />
                <Error>{ errors.get('company') }</Error>
              </div>
            </div>
            <div className='rep-edit__group'>
              <div className='rep-edit__label'>
                <label htmlFor='name'>Specialty:</label>
              </div>
              <div className='rep-edit__field'>
                <Field className='form__field form__field--rounded'
                  component='input'
                  name='specialty'
                  type='text' />
                <Error>{ errors.get('specialty') }</Error>
              </div>
            </div>
            <div className='rep-edit__group'>
              <div className='rep-edit__label'>
                <label htmlFor='products'>Products:</label>
              </div>
              <div className='rep-edit__field'>
                <Field className='form__field form__field--rounded'
                  component='input'
                  name='products'
                  type='text' />
                <Error>{ errors.get('products') }</Error>
              </div>
            </div>
            <div className='rep-edit__group'>
              <div className='rep-edit__label'>
                <label htmlFor='email'>Email:</label>
              </div>
              <div className='rep-edit__field'>
                <Field className='form__field form__field--rounded'
                  component='input'
                  name='email'
                  type='text' />
                <Error>{ errors.get('user.email') }</Error>
              </div>
            </div>
            <div className='rep-edit__group'>
              <div className='rep-edit__label'>
                <label htmlFor='phoneNumber'>Phone Number:</label>
              </div>
              <div className='rep-edit__field'>
                <Field className='form__field form__field--rounded'
                  component={ this._renderPhoneNumberInput }
                  name='phoneNumber'
                  type='text' />
                <Error>{ errors.get('phoneNumber') }</Error>
              </div>
            </div>
          </div>
          <div className='form__submit'>
            <Button className='form__button--green' loading={ currentUser.get('loading') }>Save</Button>
          </div>
        </form>
      );
    }

    // private

    _handleSubmit = this._handleSubmit.bind(this);

    _handleSubmit(e) {
      e.preventDefault();

      const { dispatch, formValues } = this.props;

      dispatch(currentRepUpdate(formValues.toJS()));
    }

    _initForm(props) {
      let currentUser = props.currentUser.get('data');

      if (currentUser) {
        const phoneNumber = currentUser.get('phoneNumber');

        currentUser = currentUser.set('phoneNumber', phoneNumber.replace(/^\+1/, ''));
      }

      if (!this.state.data.get('formInitialized') && currentUser) {
        props.dispatch(initialize(FORM_NAME, currentUser, { keepDirty: true }));

        this.setState({ data: this.state.data.set('formInitialized', true) });
      }
    }

    _renderPhoneNumberInput({ input, meta, ...rest }) {
      const value = input.value ? input.value.replace(/^\+1/, '') : '';

      return <PhoneNumberInput { ...input } { ...rest } value={ value } />;
    }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    formValues:  getFormValues(FORM_NAME)(state)
  };
};

export default (
  connect(mapStateToProps)(
    reduxForm(
      { form: FORM_NAME }
    )(PersonalInfo)
  )
);



// WEBPACK FOOTER //
// ./app/components/reps/settings/PersonalInfo.jsx